import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { getBool, getStyle, size, tablet } from 'styles';
import { row } from 'styles/layout';
import Map from 'containers/Map';
import Listings from 'containers/Listings';
import Search from 'containers/Search';
import Popup from 'containers/Popup';
import ClearButton from 'containers/ClearButton';
import { Column } from 'components';

const Container = styled.main`
  height: 100%;
  width: 100%;
  overflow: hidden;
  ${row};
`;

const StyledClearButton = styled(ClearButton)`
  position: absolute;
  bottom: ${size(5)};
  left: calc(50% - ${size(12.5)});
  ${tablet(`
    bottom: ${size(-12)};
  `)};
`;

const StyledListings = styled(Listings)``;

const SidePanel = styled(Column)`
  position: absolute;
  left: 0;
  top: 0;
  flex-shrink: 0;
  z-index: 10;
  height: 100%;
  width: ${size(120)};
  transition: ${getStyle('hue')};
  ${getBool(
    'isSearchActive',
    `
    background: ${getStyle('white')};
    pointer-events: auto;
  `,
    `
    background: ${getStyle('transparent')};
    pointer-events: none;
    ${StyledListings} {
      opacity: 0;
    }
  `,
  )};
  ${tablet(`
    width: 100%;
    height: ${size(50)};
  `)};
`;

const App = ({ isSearchActive, getEvents }) => {
  useEffect(() => {
    getEvents();
  }, []);

  return (
    <Container>
      <SidePanel isSearchActive={isSearchActive}>
        <Search />
        <StyledListings />
        <StyledClearButton />
      </SidePanel>
      <Popup />
      <Map />
    </Container>
  );
};

App.propTypes = {
  getEvents: PropTypes.func.isRequired,
  isSearchActive: PropTypes.bool.isRequired,
};

export default App;
